import {DashboardUserMeterReadingsTable} from './DashboardUserMeterReadingsTable';

export default DashboardUserMeterReadingsTable;
